<template>
    <div class="accept-container">
            <!-- <div class="go-back" v-show="goBackState" @click="goBack">GoBack</div> -->

    <!-- <iframe id="show-iframe"  frameborder=0 name="showHere" style="width:100%;" :src="linkpage"></iframe> -->
        <a :href="linkpage" target="_blank">质量报告>>></a>

    </div>
</template>

<script>
export default {
    name: 'hello',
    data () {
        return {
            goBackState:false,
            linkpage:""
        }
    },
    mounted(){
        this.linkpage = this.getLink()
        window.open(this.linkpage)
        // this.resize()
        // setTimeout(function() {
        //     window.onresize = this.resize
        // }, 200)
    },
    methods:{
        goBack(){
            this.goBackState = false;
            this.iframeState = false;
        },
        getLink(){
            return "http://sonarqube.cnzhonglunnet.com/projects"
        },
        resize(){
            const oIframe = document.getElementById('show-iframe');
            const deviceHeight = document.documentElement.clientHeight - 80;
            oIframe.style.height = deviceHeight + 'px';
        }
    }
}

</script>
<style scoped>


</style>
